import styled from '@emotion/styled'

import { colors } from '@/styles/theme'

export const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const CheckboxElement = styled.div<{ isSelected: boolean }>`
  border-radius: 6px;
  border: 1px solid;
  border-color: ${({ isSelected }) =>
    isSelected ? `${colors.navyBlue}` : `${colors.cloudyBlue}`};
  background: ${({ isSelected }) =>
    isSelected ? `${colors.navyBlue}` : `${colors.white}`};
  display: flex;
  width: 24px;
  height: 24px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const CheckboxText = styled.span`
  color: ${colors.black};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0 16px;
`
